import { render, staticRenderFns } from "./SfPrice.vue?vue&type=template&id=1b0ba986&functional=true&"
import script from "./SfPrice.vue?vue&type=script&lang=js&"
export * from "./SfPrice.vue?vue&type=script&lang=js&"
import style0 from "./SfPrice.vue?vue&type=style&index=0&id=1b0ba986&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports